/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}

var STATUS_EVENT_ACCEPTED = 204;
var STATUS_HTTP_OK = 200;
var USER_ID_NAME = 'xssuuid';
var SESSION_ID_NAME = 'xsssessionid';
var URL_TO_TRACK_ID_NAME = 'xsstrackidtourlmap_';
var SESSION_ID_HEADER_NAME = 'session';
var USER_ID_HEADER_NAME = 'user';
var TWENTY_FOUR_HOURS = 86400;

function isArray(arg) {
    return Array.isArray(arg);
}
function isHarnessQueryParamsRuleArray(arg) {
    if (!Array.isArray(arg)) {
        return false;
    }
    return arg && arg.filter(function (item) { return !(item
        && item.name !== undefined
        && item.values !== undefined
        && item.bias !== undefined); }).length === 0;
}

function processHarnessParams(query, params) {
    if (query.params === undefined) {
        return;
    }
    Object.entries(query.params).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (key === 'rules' && isHarnessQueryParamsRuleArray(value)) {
            value.forEach(function (item) {
                Object.entries(item).forEach(function (_a) {
                    var _b = __read(_a, 2), ruleKey = _b[0], ruleValue = _b[1];
                    if (ruleKey === 'values' && isArray(ruleValue)) {
                        ruleValue.forEach(function (ruleValueItem) {
                            params.append("params[" + key + "][][" + ruleKey + "][]", "" + ruleValueItem);
                        });
                        return;
                    }
                    params.set("params[" + key + "][][" + ruleKey + "]", "" + ruleValue);
                });
            });
            return;
        }
        if (key === 'dateRange') {
            Object.entries(value).forEach(function (_a) {
                var _b = __read(_a, 2), rangeKey = _b[0], rangeValue = _b[1];
                params.set("params[" + key + "][" + rangeKey + "]", "" + rangeValue);
            });
            return;
        }
        if (['itemSet', 'blacklistItems'].includes(key) && isArray(value)) {
            value.forEach(function (item) {
                params.append("params[" + key + "][]", "" + item);
            });
            return;
        }
        params.set("params[" + key + "]", "" + value);
    });
}

var SearchApiClient = /** @class */ (function () {
    function SearchApiClient(baseUrl, transport, identities) {
        this.baseUrl = baseUrl;
        this.transport = transport;
        this.identities = identities;
        this.listeners = [];
    }
    SearchApiClient.prototype.onSearch = function (cb) {
        this.listeners.push(cb);
    };
    SearchApiClient.prototype.search = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, result, total, facets, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _c = (_b = this.transport).query;
                        _d = [this.baseUrl + "/search"];
                        return [4 /*yield*/, this.prepareSearchParams(query)];
                    case 1: return [4 /*yield*/, _c.apply(_b, _d.concat([_e.sent()]))];
                    case 2:
                        _a = _e.sent(), result = _a.result, total = _a.total, facets = _a.facets;
                        this.callListeners({ total: total, facets: facets, items: result });
                        return [2 /*return*/, { total: total, facets: facets, items: result }];
                }
            });
        });
    };
    SearchApiClient.prototype.recommendationRelated = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.prepareRecommendationParams(query)];
                    case 1:
                        params = _a.sent();
                        params.set('path', query.path);
                        return [4 /*yield*/, this.transport.query(this.baseUrl + "/recommendation/related", params)];
                    case 2:
                        result = (_a.sent()).result;
                        return [2 /*return*/, { items: result }];
                }
            });
        });
    };
    SearchApiClient.prototype.recommendationHarness = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.prepareRecommendationParams(query)];
                    case 1:
                        params = _a.sent();
                        if (query.type !== undefined) {
                            params.set('type', query.type);
                        }
                        if (isArray(query.path)) {
                            query.path.forEach(function (item) {
                                params.append('path[]', "" + item);
                            });
                        }
                        else {
                            params.set('path', query.path);
                        }
                        if (query.engineId !== undefined) {
                            params.set('engineId', query.engineId);
                        }
                        processHarnessParams(query, params);
                        return [4 /*yield*/, this.transport.query(this.baseUrl + "/recommendation/harness", params)];
                    case 2:
                        result = (_a.sent()).result;
                        return [2 /*return*/, { items: result }];
                }
            });
        });
    };
    SearchApiClient.prototype.recommendationByHistory = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var params, paths, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.prepareRecommendationParams(query)];
                    case 1:
                        params = _a.sent();
                        paths = query.paths || [];
                        paths.forEach(function (item) { return params.append('paths[]', item); });
                        return [4 /*yield*/, this.transport.query(this.baseUrl + "/recommendation/byhistory", params)];
                    case 2:
                        result = (_a.sent()).result;
                        return [2 /*return*/, { items: result }];
                }
            });
        });
    };
    SearchApiClient.prototype.suggest = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = this.transport).query;
                        _c = [this.baseUrl + "/suggest"];
                        return [4 /*yield*/, this.prepareSuggestParams(query)];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([_d.sent()]))];
                    case 2:
                        result = (_d.sent()).result;
                        return [2 /*return*/, { suggests: result }];
                }
            });
        });
    };
    SearchApiClient.prototype.sendFeedback = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var headers;
            return __generator(this, function (_a) {
                headers = {
                    'Content-Type': 'application/json',
                };
                return [2 /*return*/, this.transport.post(this.baseUrl + "/feedback", JSON.stringify(data), headers)];
            });
        });
    };
    SearchApiClient.prototype.callListeners = function (result) {
        this.listeners.forEach(function (cb) { return cb(result); });
    };
    SearchApiClient.prototype.setIdentities = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var credentials;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.identities];
                    case 1:
                        credentials = _a.sent();
                        params.set(SESSION_ID_HEADER_NAME, credentials.sessionId);
                        params.set(USER_ID_HEADER_NAME, credentials.userId);
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchApiClient.prototype.prepareRecommendationParams = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = new URLSearchParams();
                params.set('domain', query.domain);
                processCustomFieldsFilter(query, params);
                if (query.exclude !== undefined && Array.isArray(query.exclude)) {
                    query.exclude.forEach(function (value) {
                        params.append('exclude[]', value);
                    });
                }
                if (query.size !== undefined) {
                    params.set('size', "" + query.size);
                }
                return [2 /*return*/, params];
            });
        });
    };
    SearchApiClient.prototype.prepareSearchParams = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new URLSearchParams();
                        params.set('query', query.query);
                        if (query.from !== undefined) {
                            params.set('from', "" + query.from);
                        }
                        if (query.size !== undefined) {
                            params.set('size', "" + query.size);
                        }
                        if (query.mode !== undefined) {
                            params.set('mode', "" + query.mode);
                        }
                        if (query.fuzzy !== undefined) {
                            params.set('fuzzy', "" + query.fuzzy);
                        }
                        if (query.customScore !== undefined) {
                            params.set('customScore', "" + query.customScore);
                        }
                        if (query.sort !== undefined && Array.isArray(query.sort)) {
                            query.sort.forEach(function (value) {
                                params.append('sort[]', value);
                            });
                        }
                        processCustomFieldsFilter(query, params);
                        if (query.dnt === true) {
                            params.append('dnt', 'true');
                        }
                        if (query.buckets === true) {
                            params.append('buckets', 'true');
                        }
                        if (query.url !== undefined && Array.isArray(query.url)) {
                            query.url.forEach(function (item) {
                                params.append('url[]', "" + item);
                            });
                        }
                        return [4 /*yield*/, this.setIdentities(params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, params];
                }
            });
        });
    };
    SearchApiClient.prototype.prepareSuggestParams = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new URLSearchParams();
                        params.set('query', query.query);
                        if (query.size !== undefined) {
                            params.set('size', "" + query.size);
                        }
                        if (query.source !== undefined) {
                            query.source.forEach(function (source) { return params.append('source', source); });
                        }
                        return [4 /*yield*/, this.setIdentities(params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, params];
                }
            });
        });
    };
    return SearchApiClient;
}());
function processCustomFieldsFilter(query, params) {
    if (query.eq !== undefined) {
        Object.entries(query.eq).forEach(function (_a) {
            var _b = __read(_a, 2), field = _b[0], values = _b[1];
            return values
                .forEach(function (value) { return params.append("eq[" + field + "]", "" + value); });
        });
    }
    if (query.ne !== undefined) {
        Object.entries(query.ne).forEach(function (_a) {
            var _b = __read(_a, 2), field = _b[0], values = _b[1];
            return values
                .forEach(function (value) { return params.append("ne[" + field + "]", "" + value); });
        });
    }
    if (query.range !== undefined) {
        Object.entries(query.range)
            .filter(function (_a) {
            var _b = __read(_a, 2), _ = _b[0], range = _b[1];
            return range && typeof (range) === 'object';
        })
            .forEach(function (_a) {
            var _b = __read(_a, 2), field = _b[0], range = _b[1];
            Object.entries(range).forEach(function (_a) {
                var _b = __read(_a, 2), op = _b[0], value = _b[1];
                if (value !== undefined) {
                    params.append("range[" + field + "][" + op + "]", value);
                }
            });
        });
    }
}

function createIdentities(userStore, sessionStore, uuidGenerator) {
    return __awaiter(this, void 0, void 0, function () {
        var userId, sessionId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, refreshUuid(userStore, USER_ID_NAME, uuidGenerator)];
                case 1:
                    userId = _a.sent();
                    return [4 /*yield*/, refreshUuid(sessionStore, SESSION_ID_NAME, uuidGenerator)];
                case 2:
                    sessionId = _a.sent();
                    return [2 /*return*/, { userId: userId, sessionId: sessionId }];
            }
        });
    });
}
function refreshUuid(store, name, uuidGenerator) {
    return __awaiter(this, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, store.get(name)];
                case 1:
                    value = _a.sent();
                    if (!value) {
                        return [2 /*return*/, store.set(name, uuidGenerator())];
                    }
                    return [2 /*return*/, value];
            }
        });
    });
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var arrayWithHoles = createCommonjsModule(function (module) {
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  module.exports = _arrayWithHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(arrayWithHoles);

var iterableToArrayLimit = createCommonjsModule(function (module) {
  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  module.exports = _iterableToArrayLimit;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(iterableToArrayLimit);

var arrayLikeToArray = createCommonjsModule(function (module) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  module.exports = _arrayLikeToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(arrayLikeToArray);

var unsupportedIterableToArray = createCommonjsModule(function (module) {
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }

  module.exports = _unsupportedIterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(unsupportedIterableToArray);

var nonIterableRest = createCommonjsModule(function (module) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableRest;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(nonIterableRest);

var slicedToArray = createCommonjsModule(function (module) {
  function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
  }

  module.exports = _slicedToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _slicedToArray = unwrapExports(slicedToArray);

var asyncToGenerator = createCommonjsModule(function (module) {
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  module.exports = _asyncToGenerator;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _asyncToGenerator = unwrapExports(asyncToGenerator);

var classCallCheck = createCommonjsModule(function (module) {
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  module.exports = _classCallCheck;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _classCallCheck = unwrapExports(classCallCheck);

var createClass = createCommonjsModule(function (module) {
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  module.exports = _createClass;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _createClass = unwrapExports(createClass);

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var regenerator = runtime_1;

var js_cookie = createCommonjsModule(function (module, exports) {

  (function (factory) {
    var registeredInModuleLoader;

    {
      module.exports = factory();
      registeredInModuleLoader = true;
    }

    if (!registeredInModuleLoader) {
      var OldCookies = window.Cookies;
      var api = window.Cookies = factory();

      api.noConflict = function () {
        window.Cookies = OldCookies;
        return api;
      };
    }
  })(function () {
    function extend() {
      var i = 0;
      var result = {};

      for (; i < arguments.length; i++) {
        var attributes = arguments[i];

        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }

      return result;
    }

    function decode(s) {
      return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }

    function init(converter) {
      function api() {}

      function set(key, value, attributes) {
        if (typeof document === 'undefined') {
          return;
        }

        attributes = extend({
          path: '/'
        }, api.defaults, attributes);

        if (typeof attributes.expires === 'number') {
          attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
        } // We're using "expires" because "max-age" is not supported by IE


        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

        try {
          var result = JSON.stringify(value);

          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}

        value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }

          stringifiedAttributes += '; ' + attributeName;

          if (attributes[attributeName] === true) {
            continue;
          } // Considers RFC 6265 section 5.2:
          // ...
          // 3.  If the remaining unparsed-attributes contains a %x3B (";")
          //     character:
          // Consume the characters of the unparsed-attributes up to,
          // not including, the first %x3B (";") character.
          // ...


          stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }

        return document.cookie = key + '=' + value + stringifiedAttributes;
      }

      function get(key, json) {
        if (typeof document === 'undefined') {
          return;
        }

        var jar = {}; // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.

        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var i = 0;

        for (; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var cookie = parts.slice(1).join('=');

          if (!json && cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
          }

          try {
            var name = decode(parts[0]);
            cookie = (converter.read || converter)(cookie, name) || decode(cookie);

            if (json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
            }

            jar[name] = cookie;

            if (key === name) {
              break;
            }
          } catch (e) {}
        }

        return key ? jar[key] : jar;
      }

      api.set = set;

      api.get = function (key) {
        return get(key, false
        /* read as raw */
        );
      };

      api.getJSON = function (key) {
        return get(key, true
        /* read as json */
        );
      };

      api.remove = function (key, attributes) {
        set(key, '', extend(attributes, {
          expires: -1
        }));
      };

      api.defaults = {};
      api.withConverter = init;
      return api;
    }

    return init(function () {});
  });
});

var DEFAULT_COOKIE_TTL = 365; // Days.
// If this script is executing in a cross-origin iframe, the cookie must
// be set with SameSite=None and Secure=true. See
// https://web.dev/samesite-cookies-explained/ and
// https://tools.ietf.org/html/draft-west-cookie-incrementalism-00 for
// details on SameSite and cross-origin behavior.

var CROSS_ORIGIN_IFRAME = amIInsideACrossOriginIframe();
var DEFAULT_SECURE = CROSS_ORIGIN_IFRAME ? true : false;
var DEFAULT_SAMESITE = CROSS_ORIGIN_IFRAME ? 'None' : 'Lax';

function amIInsideACrossOriginIframe() {
  try {
    // Raises ReferenceError if window isn't defined, eg if executed
    // outside a browser.
    //
    // If inside a cross-origin iframe, raises: Uncaught
    // DOMException: Blocked a frame with origin "..." from
    // accessing a cross-origin frame.
    return !Boolean(window.top.location.href);
  } catch (err) {
    return true;
  }
}

var CookieStore = /*#__PURE__*/function () {
  function CookieStore() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$ttl = _ref.ttl,
        ttl = _ref$ttl === void 0 ? DEFAULT_COOKIE_TTL : _ref$ttl,
        _ref$secure = _ref.secure,
        secure = _ref$secure === void 0 ? DEFAULT_SECURE : _ref$secure,
        _ref$sameSite = _ref.sameSite,
        sameSite = _ref$sameSite === void 0 ? DEFAULT_SAMESITE : _ref$sameSite;

    _classCallCheck(this, CookieStore);

    this.ttl = ttl;
    this.secure = secure;
    this.sameSite = sameSite;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }

  _createClass(CookieStore, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(key) {
        var value;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                value = js_cookie.get(key);
                return _context2.abrupt("return", typeof value === 'string' ? value : undefined);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(key, value) {
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                js_cookie.set(key, value, this._constructCookieParams());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function set(_x2, _x3) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(key) {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                js_cookie.remove(key, this._constructCookieParams());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function remove(_x4) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
  }, {
    key: "_constructCookieParams",
    value: function _constructCookieParams() {
      return {
        expires: this.ttl,
        secure: this.secure,
        sameSite: this.sameSite
      };
    }
  }]);

  return CookieStore;
}();

var Store = /*#__PURE__*/function () {
  function Store() {
    var dbName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'keyval-store';
    var storeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'keyval';

    _classCallCheck(this, Store);

    this.storeName = storeName;
    this._dbp = new Promise(function (resolve, reject) {
      var openreq = indexedDB.open(dbName, 1);

      openreq.onerror = function () {
        return reject(openreq.error);
      };

      openreq.onsuccess = function () {
        return resolve(openreq.result);
      }; // First time setup: create an empty object store


      openreq.onupgradeneeded = function () {
        openreq.result.createObjectStore(storeName);
      };
    });
  }

  _createClass(Store, [{
    key: "_withIDBStore",
    value: function _withIDBStore(type, callback) {
      var _this = this;

      return this._dbp.then(function (db) {
        return new Promise(function (resolve, reject) {
          var transaction = db.transaction(_this.storeName, type);

          transaction.oncomplete = function () {
            return resolve();
          };

          transaction.onabort = transaction.onerror = function () {
            return reject(transaction.error);
          };

          callback(transaction.objectStore(_this.storeName));
        });
      });
    }
  }]);

  return Store;
}();

var store;

function getDefaultStore() {
  if (!store) store = new Store();
  return store;
}

function get(key) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getDefaultStore();
  var req;
  return store._withIDBStore('readonly', function (store) {
    req = store.get(key);
  }).then(function () {
    return req.result;
  });
}

function set(key, value) {
  var store = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getDefaultStore();
  return store._withIDBStore('readwrite', function (store) {
    store.put(value, key);
  });
}

function del(key) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getDefaultStore();
  return store._withIDBStore('readwrite', function (store) {
    store.delete(key);
  });
}

var DEFAULT_DATABASE_NAME = 'ImmortalDB';
var DEFAULT_STORE_NAME = 'key-value-pairs';

var IndexedDbStore = /*#__PURE__*/function () {
  function IndexedDbStore() {
    var _this = this;

    var dbName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DATABASE_NAME;
    var storeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_STORE_NAME;

    _classCallCheck(this, IndexedDbStore);

    this.store = new Store(dbName, storeName);
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.store._dbp;

            case 3:
              _context.next = 12;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0.name === 'SecurityError')) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", null);

            case 11:
              throw _context.t0;

            case 12:
              return _context.abrupt("return", _this);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }))();
  }

  _createClass(IndexedDbStore, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(key) {
        var value;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return get(key, this.store);

              case 2:
                value = _context2.sent;
                return _context2.abrupt("return", typeof value === 'string' ? value : undefined);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get$1(_x) {
        return _get.apply(this, arguments);
      }

      return get$1;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(key, value) {
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return set(key, value, this.store);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function set$1(_x2, _x3) {
        return _set.apply(this, arguments);
      }

      return set$1;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(key) {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return del(key, this.store);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function remove(_x4) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
  }]);

  return IndexedDbStore;
}();

var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return _setPrototypeOf(o, p);
  }

  module.exports = _setPrototypeOf;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(setPrototypeOf);

var inherits = createCommonjsModule(function (module) {
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) setPrototypeOf(subClass, superClass);
  }

  module.exports = _inherits;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _inherits = unwrapExports(inherits);

var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return typeof obj;
      };

      module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      module.exports["default"] = module.exports, module.exports.__esModule = true;
    }

    return _typeof(obj);
  }

  module.exports = _typeof;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(_typeof_1);

var assertThisInitialized = createCommonjsModule(function (module) {
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  module.exports = _assertThisInitialized;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(assertThisInitialized);

var possibleConstructorReturn = createCommonjsModule(function (module) {
  var _typeof = _typeof_1["default"];

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return assertThisInitialized(self);
  }

  module.exports = _possibleConstructorReturn;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

var getPrototypeOf = createCommonjsModule(function (module) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return _getPrototypeOf(o);
  }

  module.exports = _getPrototypeOf;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _getPrototypeOf = unwrapExports(getPrototypeOf);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

//
// ImmortalDB - A resilient key-value store for browsers.
//
// Ansgar Grunseid
// grunseid.com
// grunseid@gmail.com
//
// License: MIT
//
var StorageApiWrapper = /*#__PURE__*/function () {
  function StorageApiWrapper(store) {
    var _this = this;

    _classCallCheck(this, StorageApiWrapper);

    this.store = store;
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }

  _createClass(StorageApiWrapper, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(key) {
        var value;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                value = this.store.getItem(key);
                return _context2.abrupt("return", typeof value === 'string' ? value : undefined);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(key, value) {
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.store.setItem(key, value);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function set(_x2, _x3) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(key) {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.store.removeItem(key);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function remove(_x4) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
  }]);

  return StorageApiWrapper;
}();

var LocalStorageStore = /*#__PURE__*/function (_StorageApiWrapper) {
  _inherits(LocalStorageStore, _StorageApiWrapper);

  var _super = _createSuper(LocalStorageStore);

  function LocalStorageStore() {
    _classCallCheck(this, LocalStorageStore);

    return _super.call(this, window.localStorage);
  }

  return LocalStorageStore;
}(StorageApiWrapper);

var SessionStorageStore = /*#__PURE__*/function (_StorageApiWrapper2) {
  _inherits(SessionStorageStore, _StorageApiWrapper2);

  var _super2 = _createSuper(SessionStorageStore);

  function SessionStorageStore() {
    _classCallCheck(this, SessionStorageStore);

    return _super2.call(this, window.sessionStorage);
  }

  return SessionStorageStore;
}(StorageApiWrapper);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var cl = console.log;
var DEFAULT_KEY_PREFIX = '_immortal|';
var WINDOW_IS_DEFINED = typeof window !== 'undefined'; // Stores must implement asynchronous constructor, get(), set(), and
// remove() methods.

var DEFAULT_STORES = [CookieStore];

try {
  if (WINDOW_IS_DEFINED && window.indexedDB) {
    DEFAULT_STORES.push(IndexedDbStore);
  }
} catch (err) {}

try {
  if (WINDOW_IS_DEFINED && window.localStorage) {
    DEFAULT_STORES.push(LocalStorageStore);
  }
} catch (err) {}

function arrayGet(arr, index) {
  var _default = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (index in arr) {
    return arr[index];
  }

  return _default;
}

function countUniques(iterable) {
  // A Map must be used instead of an Object because JavaScript is a
  // buttshit language and all Object keys are serialized to strings.
  // Thus undefined becomes 'undefined', null becomes 'null', etc. Then,
  // in turn, 'undefined' can't be differentiated from undefined, null
  // from 'null', etc, and countUniques([null, 'null']) would
  // incorrectly return {'null': 2} instead of {null: 1, 'null': 1}.
  //
  // Unfortunately this Object behavior precludes the use of
  // lodash.countBy() and similar methods which count with Objects
  // instead of Maps.
  var m = new Map();
  var eles = iterable.slice();

  var _iterator = _createForOfIteratorHelper(eles),
      _step;

  try {
    var _loop = function _loop() {
      var ele = _step.value;
      var count = 0;

      var _iterator2 = _createForOfIteratorHelper(eles),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var obj = _step2.value;

          if (ele === obj) {
            count += 1;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (count > 0) {
        m.set(ele, count);
        eles = eles.filter(function (obj) {
          return obj !== ele;
        });
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return m;
}

var ImmortalStorage = /*#__PURE__*/function () {
  function ImmortalStorage() {
    var _this = this;

    var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STORES;

    _classCallCheck(this, ImmortalStorage);

    this.stores = []; // Initialize stores asynchronously. Accept both instantiated store
    // objects and uninstantiated store classes. If the latter,
    // implicitly instantiate instances thereof in this constructor.
    //
    // This constructor must accept both instantiated store objects and
    // uninstantiated store classes because it's impossible to export
    // ImmortalStore if it only took store objects initialized
    // asynchronously. Like:
    //
    //   ;(async () => {
    //       const cookieStore = await CookieStore()
    //       const ImmortalDB = new ImmortalStorage([cookieStore])
    //       export { ImmortalDB }  // <----- Doesn't work.
    //   })
    //
    // So to export a synchronous ImmortalStorage class, datastore
    // classes (whose definitions are synchronous) must be accepted in
    // addition to instantiated store objects.

    this.onReady = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Promise.all(stores.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(StoreClassOrInstance) {
                  return regenerator.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(typeof StoreClassOrInstance === 'object')) {
                            _context.next = 4;
                            break;
                          }

                          return _context.abrupt("return", StoreClassOrInstance);

                        case 4:
                          _context.prev = 4;
                          _context.next = 7;
                          return new StoreClassOrInstance();

                        case 7:
                          return _context.abrupt("return", _context.sent);

                        case 10:
                          _context.prev = 10;
                          _context.t0 = _context["catch"](4);
                          return _context.abrupt("return", null);

                        case 13:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[4, 10]]);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 2:
              _this.stores = _context2.sent.filter(Boolean);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }

  _createClass(ImmortalStorage, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(key) {
        var _default,
            prefixedKey,
            values,
            counted,
            value,
            _arrayGet,
            _arrayGet2,
            firstValue,
            firstCount,
            _arrayGet3,
            _arrayGet4,
            secondValue,
            secondCount,
            _args4 = arguments;

        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _default = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : null;
                _context4.next = 3;
                return this.onReady;

              case 3:
                prefixedKey = "".concat(DEFAULT_KEY_PREFIX).concat(key);
                _context4.next = 6;
                return Promise.all(this.stores.map( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(store) {
                    return regenerator.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return store.get(prefixedKey);

                          case 3:
                            return _context3.abrupt("return", _context3.sent);

                          case 6:
                            _context3.prev = 6;
                            _context3.t0 = _context3["catch"](0);
                            cl(_context3.t0);

                          case 9:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, null, [[0, 6]]);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 6:
                values = _context4.sent;
                counted = Array.from(countUniques(values).entries());
                counted.sort(function (a, b) {
                  return a[1] <= b[1];
                });
                _arrayGet = arrayGet(counted, 0, [undefined, 0]), _arrayGet2 = _slicedToArray(_arrayGet, 2), firstValue = _arrayGet2[0], firstCount = _arrayGet2[1];
                _arrayGet3 = arrayGet(counted, 1, [undefined, 0]), _arrayGet4 = _slicedToArray(_arrayGet3, 2), secondValue = _arrayGet4[0], secondCount = _arrayGet4[1];

                if (firstCount > secondCount || firstCount === secondCount && firstValue !== undefined) {
                  value = firstValue;
                } else {
                  value = secondValue;
                }

                if (!(value !== undefined)) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 15;
                return this.set(key, value);

              case 15:
                return _context4.abrupt("return", value);

              case 18:
                _context4.next = 20;
                return this.remove(key);

              case 20:
                return _context4.abrupt("return", _default);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function get(_x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(key, value) {
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.onReady;

              case 2:
                key = "".concat(DEFAULT_KEY_PREFIX).concat(key);
                _context6.next = 5;
                return Promise.all(this.stores.map( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(store) {
                    return regenerator.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.prev = 0;
                            _context5.next = 3;
                            return store.set(key, value);

                          case 3:
                            _context5.next = 8;
                            break;

                          case 5:
                            _context5.prev = 5;
                            _context5.t0 = _context5["catch"](0);
                            cl(_context5.t0);

                          case 8:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, null, [[0, 5]]);
                  }));

                  return function (_x6) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 5:
                return _context6.abrupt("return", value);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function set(_x4, _x5) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(key) {
        return regenerator.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.onReady;

              case 2:
                key = "".concat(DEFAULT_KEY_PREFIX).concat(key);
                _context8.next = 5;
                return Promise.all(this.stores.map( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(store) {
                    return regenerator.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            _context7.prev = 0;
                            _context7.next = 3;
                            return store.remove(key);

                          case 3:
                            _context7.next = 8;
                            break;

                          case 5:
                            _context7.prev = 5;
                            _context7.t0 = _context7["catch"](0);
                            cl(_context7.t0);

                          case 8:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7, null, [[0, 5]]);
                  }));

                  return function (_x8) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function remove(_x7) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
  }]);

  return ImmortalStorage;
}();

var ImmortalDB = new ImmortalStorage();

function createSessionStorage() {
    return new ImmortalStorage([SessionStorageStore]);
}
function createStorage() {
    return new ImmortalStorage([LocalStorageStore, IndexedDbStore, SessionStorageStore]);
}

var XhrError = /** @class */ (function (_super) {
    __extends(XhrError, _super);
    function XhrError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XhrError;
}(Error));

/** `XHR` based transport */
var XHRBackend = /** @class */ (function () {
    function XHRBackend(options) {
        this.options = options;
    }
    XHRBackend.prototype.event = function (url, body, headers) {
        if (headers === void 0) { headers = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var request = createXHR(url, 'POST', headers);
                        request.onreadystatechange = function () {
                            if (request.readyState !== 4) {
                                return;
                            }
                            resolve(request.status === STATUS_EVENT_ACCEPTED);
                        };
                        request.send(body);
                    })];
            });
        });
    };
    XHRBackend.prototype.post = function (url, body, headers) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var request = createXHR(url, 'POST', headers);
                        request.onreadystatechange = function () {
                            onReadyStateChange(request, resolve, reject);
                        };
                        request.send(body);
                    })];
            });
        });
    };
    XHRBackend.prototype.query = function (url, query, headers) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var request = createXHR(url + "?" + query, 'GET', headers);
                        request.onreadystatechange = function () {
                            onReadyStateChange(request, resolve, reject);
                        };
                        request.send();
                    })];
            });
        });
    };
    return XHRBackend;
}());
function createXHR(url, method, headers) {
    var request = new XMLHttpRequest();
    request.open(method, url);
    if (headers) {
        Object.entries(headers).forEach(function (_a) {
            var _b = __read(_a, 2), name = _b[0], value = _b[1];
            request.setRequestHeader(name, value);
        });
    }
    return request;
}
function onReadyStateChange(request, resolve, reject) {
    if (request.readyState !== 4) {
        return;
    }
    if (request.status === STATUS_HTTP_OK) {
        try {
            var json = JSON.parse(request.responseText);
            resolve(json || {});
            return;
        }
        catch (e) {
            reject(e);
            return;
        }
    }
    var err = new XhrError("Server error [" + request.status + "]");
    err.request = request;
    reject(err);
}

var EventsApiClient = /** @class */ (function () {
    function EventsApiClient(baseUrl, transport, idGenerator, getUnixTimestamp, baseUrlWithApikey, identities) {
        this.baseUrl = baseUrl;
        this.transport = transport;
        this.idGenerator = idGenerator;
        this.getUnixTimestamp = getUnixTimestamp;
        this.baseUrlWithApikey = baseUrlWithApikey;
        this.identities = identities;
    }
    EventsApiClient.prototype.sendEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var eventWithCredentials;
            return __generator(this, function (_a) {
                eventWithCredentials = _assign(_assign({}, event), { timestamp: this.getUnixTimestamp(), eventId: this.idGenerator() });
                return [2 /*return*/, this.transport.event(this.baseUrl + "/events", JSON.stringify(eventWithCredentials))];
            });
        });
    };
    EventsApiClient.prototype.sendRecommendationEvent = function (events) {
        return __awaiter(this, void 0, void 0, function () {
            var identities, date, eventsWithDefaults;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.identities];
                    case 1:
                        identities = _a.sent();
                        date = new Date(this.getUnixTimestamp() * 1000);
                        eventsWithDefaults = events
                            .map(function (_a) {
                            var engineId = _a.engineId, data = _a.data;
                            return ({
                                engineId: engineId,
                                data: _assign({ entityId: identities.userId, targetEntityType: 'item', entityType: 'user', eventTime: date.toISOString() }, data),
                            });
                        });
                        return [2 /*return*/, this.transport.event(this.baseUrlWithApikey + "/recommendationEvent", JSON.stringify(eventsWithDefaults))];
                }
            });
        });
    };
    return EventsApiClient;
}());

/** `sendBeacon` based transport */
var BeaconBackend = /** @class */ (function () {
    function BeaconBackend(options) {
        this.options = options;
    }
    BeaconBackend.prototype.event = function (url, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, Promise.resolve(this.options.global.navigator.sendBeacon(url, data))];
                }
                catch (e) {
                    // chrome can throw in beacon :/
                    return [2 /*return*/, Promise.resolve(false)];
                }
                return [2 /*return*/];
            });
        });
    };
    return BeaconBackend;
}());

var UrlDictionary = /** @class */ (function () {
    function UrlDictionary(apiKey, storage, getUnixTimestamp) {
        this.apiKey = apiKey;
        this.storage = storage;
        this.getUnixTimestamp = getUnixTimestamp;
    }
    UrlDictionary.prototype.find = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var map, item;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromStorage()];
                    case 1:
                        map = _a.sent();
                        item = map.get(url);
                        if (item) {
                            return [2 /*return*/, item.trackId || undefined];
                        }
                        return [2 /*return*/, undefined];
                }
            });
        });
    };
    UrlDictionary.prototype.save = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var time, yesterday, extendedData, mapFromStorage, currentData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        time = this.getUnixTimestamp();
                        yesterday = time - TWENTY_FOUR_HOURS;
                        extendedData = data.map(function (_a) {
                            var _b = __read(_a, 2), url = _b[0], trackId = _b[1];
                            return [url, { trackId: trackId, time: time }];
                        });
                        return [4 /*yield*/, this.getDataFromStorage()];
                    case 1:
                        mapFromStorage = _a.sent();
                        currentData = __spread(mapFromStorage.entries()).filter(function (_a) {
                            var _b = __read(_a, 2), val = _b[1];
                            return val.time >= yesterday;
                        });
                        this.storage.set(URL_TO_TRACK_ID_NAME + this.apiKey, JSON.stringify(__spread(currentData, extendedData)));
                        return [2 /*return*/];
                }
            });
        });
    };
    UrlDictionary.prototype.getDataFromStorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storage.get(URL_TO_TRACK_ID_NAME + this.apiKey)];
                    case 1:
                        map = _a.sent();
                        if (!map) {
                            return [2 /*return*/, new Map()];
                        }
                        try {
                            return [2 /*return*/, new Map(JSON.parse(map))];
                        }
                        catch (e) {
                            return [2 /*return*/, new Map()];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return UrlDictionary;
}());

/**
 * Check if target is Anchor else try to find closest parent Anchor element
 * @param target
 */
function findAnchorElement(target) {
    if (!target) {
        return null;
    }
    if (target instanceof HTMLAnchorElement) {
        return target;
    }
    return (target instanceof HTMLElement) ? target.closest('a') : null;
}

function runClickTracker(window, urlDictionary, eventsApiClient, searchApiClient, watchClicks) {
    if (watchClicks === void 0) { watchClicks = true; }
    searchApiClient
        .onSearch(function (results) { return saveResults(urlDictionary, results); });
    if (!watchClicks) {
        return;
    }
    // auxclick - middle click
    ['click', 'auxclick'].forEach(function (eventType) {
        document.addEventListener(eventType, function (event) {
            return processClick(window, eventsApiClient, urlDictionary, event);
        });
    });
}
function saveResults(urlDictionary, results) {
    return __awaiter(this, void 0, void 0, function () {
        var items, mapped;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    items = results.items || {};
                    if (!items || !items.length) {
                        return [2 /*return*/];
                    }
                    mapped = items.map(function (item) { return [item.url, item.trackId]; });
                    return [4 /*yield*/, urlDictionary.save(mapped)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function processClick(window, eventsApiClient, urlDictionary, _a) {
    var target = _a.target;
    return __awaiter(this, void 0, void 0, function () {
        var anchor, url, trackId, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    anchor = findAnchorElement(target);
                    if (!anchor) {
                        return [2 /*return*/, true];
                    }
                    url = anchor.getAttribute('href');
                    if (!url) {
                        return [2 /*return*/, true];
                    }
                    return [4 /*yield*/, urlDictionary.find(url)];
                case 1:
                    trackId = _b.sent();
                    if (!trackId) {
                        // @TODO may be we should collect clicks in search result container despite lack of trackId?
                        return [2 /*return*/, true];
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, eventsApiClient.sendEvent({ trackId: trackId, type: 'click' })];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _b.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, true];
            }
        });
    });
}

function runVisitTracker(global, urlDictionary, eventsApiClient, getUnixTimestamp) {
    var startupTime = getUnixTimestamp();
    global.addEventListener('beforeunload', function () {
        processPageUnload(global, document.location.toString(), urlDictionary, startupTime, eventsApiClient, getUnixTimestamp);
        return;
    });
}
function processPageUnload(window, currentUrl, urlDictionary, startupTime, eventsApiClient, getUnixTimestamp) {
    return __awaiter(this, void 0, void 0, function () {
        var trackId, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, urlDictionary.find(currentUrl)];
                case 1:
                    trackId = _a.sent();
                    if (!trackId) {
                        return [2 /*return*/];
                    }
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, eventsApiClient.sendEvent({
                            trackId: trackId,
                            type: 'visit',
                            timeElapsed: getUnixTimestamp() - startupTime,
                        })];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}

function getUnixTimestamp() {
    return Math.round(new Date().getTime() / 1000);
}
/**
 * Tells whether current environment supports sendBeacon API
 * {@link supportsBeacon}.
 *
 * @returns Answer to the given question.
 */
function supportsBeacon(global) {
    if (global === void 0) { global = window; }
    return 'navigator' in global && 'sendBeacon' in global.navigator;
}
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function generateUUIDv4(global) {
    if (global === void 0) { global = window; }
    var bytes = getRandomBytes(16, global);
    // tslint:disable-next-line
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version
    // tslint:disable-next-line
    bytes[8] = (bytes[8] & 0xbf) | 0x80; // variant
    return [
        toHexString(bytes.subarray(0, 4)),
        toHexString(bytes.subarray(4, 6)),
        toHexString(bytes.subarray(6, 8)),
        toHexString(bytes.subarray(8, 10)),
        toHexString(bytes.subarray(10, 16)),
    ].join('-');
}
function toHexString(bytes) {
    var s = '';
    // tslint:disable-next-line
    for (var i = 0; i < bytes.length; i++) {
        s += bytes[i].toString(16).padStart(2, '0');
    }
    return s;
}
function getRandomBytes(length, global) {
    var crypto = global.crypto || global.msCrypto;
    var bytes = new Uint8Array(length);
    return crypto && crypto.getRandomValues
        ? crypto.getRandomValues(bytes)
        : getRandomValuesWithMathRandom(bytes);
}
function getRandomValuesWithMathRandom(bytes) {
    var max = Math.pow(2, 8 * bytes.byteLength / bytes.length);
    // tslint:disable-next-line
    for (var i = 0; i < bytes.length; i++) {
        bytes[i] = Math.random() * max;
    }
    return bytes;
}

var UUIDv4 = generateUUIDv4;
/**
 * creates search Api and events Api clients
 *
 * @param baseUrl
 * @param global
 * @param eventTransport
 * @param searchTransport
 */
function createApiClients(_a) {
    var apiKey = _a.apiKey, _b = _a.domain, domain = _b === void 0 ? 'https://api-search.xiag.ch' : _b, _c = _a.global, global = _c === void 0 ? window : _c, eventTransport = _a.eventTransport, searchTransport = _a.searchTransport;
    var storage = createStorage();
    var sessionStorage = createSessionStorage();
    var identities = createIdentities(storage, sessionStorage, generateUUIDv4);
    var searchClient = new SearchApiClient(domain + "/v2/" + apiKey, searchTransport
        ? searchTransport
        : createSearchTransport({ global: global }), identities);
    var eventsClient = new EventsApiClient("" + domain, eventTransport
        ? eventTransport
        : createEventsTransport({ global: global }), generateUUIDv4, getUnixTimestamp, domain + "/v2/" + apiKey, identities);
    return {
        searchClient: searchClient,
        eventsClient: eventsClient,
        apiKey: apiKey,
        identities: identities,
    };
}
/**
 * Run click tracking on page
 * usage example
 * ```
 * const searchClients = createApiClients({ apiKey: 'apikey' });
 * startClickTracking(searchClients);
 * ```
 *
 * @param global
 * @param searchClient
 * @param eventsClient
 * @param apiKey
 */
function startClickTracking(_a) {
    var _b = _a.global, global = _b === void 0 ? window : _b, searchClient = _a.searchClient, eventsClient = _a.eventsClient, apiKey = _a.apiKey, _c = _a.watchClicks, watchClicks = _c === void 0 ? true : _c;
    var dictionary = new UrlDictionary(apiKey, createStorage(), getUnixTimestamp);
    runClickTracker(global, dictionary, eventsClient, searchClient, watchClicks);
}
/**
 * Run visit tracking on page
 * usage example
 * ```
 * const searchClients = createApiClients({ apiKey: 'apikey' });
 * startVisitTracking(searchClients);
 * ```
 *
 * @param global
 * @param searchClient
 * @param eventsClient
 * @param apiKey
 */
function startVisitTracking(_a) {
    var _b = _a.global, global = _b === void 0 ? window : _b, searchClient = _a.searchClient, eventsClient = _a.eventsClient, apiKey = _a.apiKey;
    var dictionary = new UrlDictionary(apiKey, createStorage(), getUnixTimestamp);
    runVisitTracker(global, dictionary, eventsClient, getUnixTimestamp);
}
function createSearchTransport(options) {
    return new XHRBackend(options);
}
function createEventsTransport(options) {
    return supportsBeacon(options.global) ? new BeaconBackend(options) : new XHRBackend(options);
}

export { UUIDv4, createApiClients, createXHR, onReadyStateChange, startClickTracking, startVisitTracking };
